// extracted by mini-css-extract-plugin
export default {"grid":"QuinellaField_grid__Wxvnw","boxed":"QuinellaField_boxed__uigZb"};